import React from 'react';
import { Star, ShieldCheck } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="bg-dark text-white pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden" data-id="element-80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-82">
          {/* Text Content */}
          <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-83">
            <FadeIn data-id="element-84">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6" data-id="element-85">
                5K SIN <span className="text-primary" data-id="element-86">RENDIRSE</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-87">
              <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-2xl" data-id="element-88">
                El método paso a paso para pasar de sedentario a correr 5K en 8
                semanas… sin abandonar en el intento.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} className="w-full sm:w-auto flex flex-col items-center lg:items-start" data-id="element-89">
              <CTAButton className="mb-6 w-full sm:w-auto" data-id="element-90">
                QUIERO EMPEZAR HOY →
              </CTAButton>

              <div className="flex flex-col items-center lg:items-start gap-2" data-id="element-91">
                <div className="flex items-center gap-1 text-primary" data-id="element-92">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-93" />)}
                </div>
                <p className="text-sm text-gray-400 font-medium" data-id="element-94">
                  ⭐ +500 personas ya lo lograron
                </p>
                <div className="flex items-center gap-2 mt-2 text-xs text-gray-500" data-id="element-95">
                  <ShieldCheck className="w-4 h-4 text-success" data-id="element-96" />
                  <span data-id="element-97">Compra 100% Segura</span>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Image/Mockup */}
          <div className="w-full lg:w-1/2 relative" data-id="element-98">
            <FadeIn delay={0.3} direction="left" data-id="element-99">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] md:aspect-square lg:aspect-[4/5]" data-id="element-100">
                <div className="absolute inset-0 bg-gradient-to-t from-dark/80 to-transparent z-10" data-id="element-101"></div>
                <img src="https://images.unsplash.com/photo-1552674605-171d31fea3fa?auto=format&fit=crop&w=1000&q=80" alt="Persona atándose los cordones para correr" className="w-full h-full object-cover" data-id="element-102" />
                <div className="absolute bottom-6 left-6 right-6 z-20" data-id="element-103">
                  <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-xl p-4" data-id="element-104">
                    <p className="text-white font-medium text-sm md:text-base" data-id="element-105">
                      "El único plan diseñado para los que siempre abandonan."
                    </p>
                  </div>
                </div>
              </div>

              {/* Decorative elements */}
              <div className="absolute -top-6 -right-6 w-24 h-24 bg-primary/20 rounded-full blur-2xl" data-id="element-106"></div>
              <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-primary/10 rounded-full blur-3xl" data-id="element-107"></div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}